import React from "react";

import { useState, useEffect } from "react";
import MockNavigation from "./MockNavigation";
import KeyBoardCheckPage from "./KeyboardCheckPage";
import HeadphoneCheckPage from "./HeadphonePage";
import MicrophoneCheckPage from "./MicrophonePage";
import ReadAloudPage from "./Speaking/ReadAloudPage";
import RepeatSentencePage from "./Speaking/RepeatSentencePage";
import DescribeImageMockPage from "./Speaking/DescribeImageMock";
import ReTellMockPage from "./Speaking/ReTellMock";
import ShortAnswersMockPage from "./Speaking/ShortAnswersMock";
import SummarizeGroupDisscusionMockPage from "./Speaking/SummarizeGroupDiscussionMock";
import RespondToSituationMockPage from "../../pages/MockTest/Speaking/RespondToSituation";

import Notification from "../QuestionPage/Notification";
import ConfirmDialog from "./PopUp";
import Loading from "./SpinnerLoading"; // Import the loading component
import SpeakingSectionTable from "./SpeakingSectionTable";

// function ConfirmDialog({ message, onConfirm, onCancel }) {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         backgroundColor: "white",
//         border: "1px solid #ccc",
//         padding: "20px",
//         zIndex: 1000,
//       }}
//     >
//       <p>{message}</p>
//       <button onClick={onConfirm}>Yes</button>
//       <button onClick={onCancel}>No</button>
//     </div>
//   );
// }

// Page Html
export default function SpeakingMockTestPage() {
  const [MockData, setMockData] = useState({
    data: [],
  });
  const [userInputs, setUserInputs] = useState({});

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [nextPage, setNextPage] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // New state for loading

  useEffect(() => {
    const fetchMockData = async () => {
      try {
        const response = await fetch("/api/speakingmockquestions/all", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setMockData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch MockTest data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching MockTest data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchMockData();
  }, []);

  console.log("Mock Data:", MockData.data.AnswershortQuestion);

  const handleInputChange = (questionType, questionIndex, answer) => {
    setUserInputs((prevInputs) => ({
      ...prevInputs,
      [questionType]: {
        ...prevInputs[questionType],
        [questionIndex]: answer,
      },
    }));
  };

  console.log("User Input", userInputs);

  const splitData = (data, size) => {
    const chunks = [];
    for (let i = 0; i < data.length; i += size) {
      chunks.push(data.slice(i, i + size));
    }
    return chunks;
  };

  const handleSubmit = async () => {
    const payload = { userInputs, MockData }; // Assuming userInputs and MockData are defined
    const payloadString = JSON.stringify(payload);
    const maxChunkSize = 50000; // Reduce the chunk size further (e.g., 50KB)
    const chunks = splitData(payloadString, maxChunkSize);

    console.log(`Total chunks: ${chunks.length}`);

    try {
      for (const [index, chunk] of chunks.entries()) {
        console.log(`Sending chunk ${index + 1} of ${chunks.length}`);
        const response = await fetch("/api/save-speakingmocktestdata", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ chunk, index, totalChunks: chunks.length }),
        });
        if (!response.ok) {
          console.error(
            "Failed to submit data chunk. Status:",
            response.status
          );
          setMessage("Failed to save practice data.");
          setNotificationType("error");
          setShowNotification(true); // Show notification
          setLoading(false);
          setSubmitted(false);

          break;
        }
      }
      console.log("Data submitted successfully");
      setMessage("Mock data saved successfully!");
      setNotificationType("success");
      setShowNotification(true); // Show notification

      setTimeout(() => {
        setLoading(false);
        setSubmitted(true);
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  // Empty dependency array to fetch data only once on mount
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 40;
  const handleNext = () => {
    setShowConfirmDialog(true);
    setNextPage((prevPage) => prevPage + 1);
  };

  const handleConfirm = () => {
    setShowConfirmDialog(false);
    setIsLoading(true); // Start loading

    // Set timeout to simulate loading delay
    setTimeout(() => {
      setIsLoading(false); // End loading
      setCurrentPage(nextPage); // Proceed to the next page
    }, 100);
  };

  const handleCancel = () => {
    setShowConfirmDialog(false); // Hide the confirmation dialog
  };

  const handlePrevious = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const disableNext = currentPage === totalPages;
  const disablePrevious = currentPage === 1;

  const renderPage = () => {
    // ReadAloud → Q1–6
    if (currentPage >= 5 && currentPage <= 10) {
      const questionIndex = currentPage - 5;
      const currentQuestion = MockData.data.Readaloud[questionIndex];
      return (
        <ReadAloudPage
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("Readaloud", questionIndex, answer)
          }
          questionNumber={questionIndex + 1} // Q1–6
        />
      );
    }

    // RepeatSentence → Q7–18

    if (currentPage >= 11 && currentPage <= 22) {
      const questionIndex = currentPage - 11;
      const currentQuestion = MockData.data.RepeatSentence[questionIndex];
      return (
        <RepeatSentencePage
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("RepeatSentence", questionIndex, answer)
          }
          questionNumber={questionIndex + 7} // Q7–18
        />
      );
    }
    // DescribeImage → Q19–24

    if (currentPage >= 23 && currentPage <= 28) {
      const questionIndex = currentPage - 23;
      const currentQuestion = MockData.data.DescribeImage[questionIndex];
      return (
        <DescribeImageMockPage
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("DescribeImage", questionIndex, answer)
          }
          questionNumber={questionIndex + 19} // Q19–24
        />
      );
    }
    // RetellLecture → Q25–26

    if (currentPage >= 29 && currentPage <= 30) {
      const questionIndex = currentPage - 29;
      const currentQuestion = MockData.data.RetellLecture[questionIndex];
      return (
        <ReTellMockPage
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("ReTellLecture", questionIndex, answer)
          }
          questionNumber={questionIndex + 25} // Q25–26
        />
      );
    }
    // AnswerShortQuestion → Q27–32

    if (currentPage >= 31 && currentPage <= 36) {
      const questionIndex = currentPage - 31;
      const currentQuestion = MockData.data.AnswershortQuestion[questionIndex];
      return (
        <ShortAnswersMockPage
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("AnswershortQuestion", questionIndex, answer)
          }
          questionNumber={questionIndex + 27} // Q27–32
        />
      );
    }
    // SummarizeGroupDiscussion → Q33–34

    if (currentPage >= 37 && currentPage <= 38) {
      const questionIndex = currentPage - 37;
      const currentQuestion =
        MockData.data.SummarizeGroupDiscussion[questionIndex];
      return (
        <SummarizeGroupDisscusionMockPage
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("SummarizeGroupDiscussion", questionIndex, answer)
          }
          questionNumber={questionIndex + 33} // Q33–34
        />
      );
    }
    // RespondToSituation → Q35–36

    if (currentPage >= 39 && currentPage <= 40) {
      const questionIndex = currentPage - 39;
      const currentQuestion = MockData.data.RespondToSituation[questionIndex];
      return (
        <RespondToSituationMockPage
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("RespondToSituation", questionIndex, answer)
          }
          questionNumber={questionIndex + 35} // Q35–36
        />
      );
    }

    switch (currentPage) {
      case 1:
        return <HeadphoneCheckPage />;
      case 2:
        return <MicrophoneCheckPage />;
      case 3:
        return <KeyBoardCheckPage />;
      case 4:
        return <SpeakingSectionTable />;

      // case 26:
      //   return <WriteFromDictationMockPage />;

      default:
        return null;
    }
  };

  return (
    <div>
      {renderPage()}
      {isLoading && <Loading />}
      {showConfirmDialog && (
        <ConfirmDialog
          message="Proceed to the next question?"
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
      <MockNavigation
        onNext={handleNext}
        onPrevious={handlePrevious}
        disableNext={disableNext}
        disablePrevious={disablePrevious}
        currentPage={currentPage} // Pass currentPage here
        totalPages={totalPages} // Pass totalPages here
        handleSubmit={handleSubmit} // Pass handleSubmit here
      />

      {showNotification && (
        <Notification
          message={message}
          type={notificationType}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
}
